import { useMutation, useQueryClient } from "@tanstack/react-query";

import { likeComment, unlikeComment } from "../services/commentServices";
import { FEED_QUERY_KEYS } from "../queryKeys";

interface UseCommentLikeMutationProps {
  commentId: number;
  postId: number;
}

export const useCommentLikeMutation = ({ commentId, postId }: UseCommentLikeMutationProps) => {
  const queryClient = useQueryClient();

  const likeMutation = useMutation({
    mutationFn: () => likeComment(commentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.commentData(commentId) });
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.postData(postId) });
    },
  });

  const unlikeMutation = useMutation({
    mutationFn: () => unlikeComment(commentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.commentData(commentId) });
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.postData(postId) });
    },
  });

  return {
    likeComment: likeMutation.mutate,
    isLiking: likeMutation.isPending,
    unlikeComment: unlikeMutation.mutate,
    isUnliking: unlikeMutation.isPending,
  };
};
